<div class="container mt-5">
    <h3>Aktion importieren</h3>
    <p>
        Hier können Aktionen neu importiert oder bearbeitet werden. Mit dem Download der Vorlage, können neue Aktionen angelegt werden. Folgenden Dinge sollten berücksichtigt werden:

        - Alter = 99
    - Schwimmabzeichen
    - ID
    </p>
    <ul>
        <li class="mb-2">Altersangabe: <br>
            Wenn man bei Max-Alter 99 einträgt, wird in System das Alter mit "Ab" ausgegeben. Ansonsten wird von-bis angeben.<br>
            Beispiel: Min: 4, Max: 99 Dann: Ab 4 Jahre<br>
            Beispiel: Min: 4, Max: 12 Dann: 4-12 Jahre
        </li>
        <li class="mb-2">Schwimmabzeichen:<br>
            Es gibt folgende Schwimmabzeichen, die genau so eingetragen werden müssen:<br>
            KEINS, SEEPFERDCHEN, BRONZE, SILBER, GOLD
        </li>
        <li>Update Aktion
            Wenn man in der Spalte ID eine Aktions-ID einträgt, so wird diese dann aktualisiert und nicht neu angelegt. Dies kann man gut mit dem Export zusammen nutzen.
        </li>
    </ul>
    <button class="btn pcButton mr-4" (click)="downloadVorlage()">Download Vorlage</button>
    <button class="btn pcButton mr-4" (click)="exportAktionen()">Export Aktionen</button>
    <input type="file" (change)="import($event)" accept=".xlsx">

</div>
    <table *ngIf="aktionen.length > 0" class="table table-striped">
        <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Datum</th>
            <th>Start</th>
            <th>Ende</th>
            <th>Ort</th>
            <th>Veranstalter</th>
            <th>Alter</th>
            <th>Preis</th>
            <th>Sozi-Preis</th>
            <th>Max-TN</th>
            <th>Schwimmabzeichen</th>
            <th><button class="btn pcButton" (click)="saveAll()" [disabled]="!anyReady || saving">Alle Speichern</button></th>
        </tr>
        <tr *ngFor="let a of aktionen; let i = index;">
            <td>{{ a.id }}</td>
            <td>{{ a.titel }}</td>
            <td>{{ a | aktionDate: "date"}}</td>
            <td>{{ a | aktionDate: "timeStart"}}</td>
            <td>{{ a | aktionDate: "timeEnd"}}</td>
            <td>{{ a.ort }}</td>
            <td>{{ a.veranstalter }}</td>
            <td>{{ a | aktionAlter }}</td>
            <td>{{ a.preis.toFixed(2) }} €</td>
            <td>{{ a.soziPreis.toFixed(2) }} €</td>
            <td>{{ a.maxKinder }}</td>
            <td>{{ a.schwimmabzeichen}}</td>
            <td><button class="btn pcButton" (click)="saveAktion(i)" [disabled]="saveStates[i].state !== SaveState.READY || saving">Speichern</button> <i class="ml-2 fas fa-circle {{saveStates[i].state}}" [ngbTooltip]="saveStates[i].message"></i> </td>
        </tr>
        <tr>
            <td colspan="13"><i class="fas fa-circle READY"></i> Bereit zum Speichern |
                <i class="fas fa-circle INVALID"></i> Einige Daten sind nicht gültig |
                <i class="fas fa-circle SAVING"></i> Wird gespeichert |
                <i class="fas fa-circle DONE"></i> Wurde gespeichert |
                <i class="fas fa-circle ERROR"></i> Es gab ein Fehler</td>
        </tr>
    </table>
